import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ProspectToLawFirmFormService {

  public bearer: string|undefined;
}
